/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface EntityId
 */
export interface EntityId {
}

/**
 * Check if a given object implements the EntityId interface.
 */
export function instanceOfEntityId(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function EntityIdFromJSON(json: any): EntityId {
    return EntityIdFromJSONTyped(json, false);
}

export function EntityIdFromJSONTyped(json: any, ignoreDiscriminator: boolean): EntityId {
    return json;
}

export function EntityIdToJSON(value?: EntityId | null): any {
    return value;
}

